<template>
  <valid-van-field
    v-model="col"
    :label="label"
    :placeholder="placeholder"
    :rules="reg"
    :readonly="readonly"
     :maxlength="maxlength"
  />
</template>

<script>
import { Field } from 'vant';
import ValidHoc from '@/components/valid';

const ValidVanField = ValidHoc(Field);
export default {
  name: 'BindInput',
  components: {
    ValidVanField,
  },
  props: ['label', 'placeholder', 'reg', 'model', 'readonly', 'maxlength'],
  computed: {
    col: {
      get() {
        return this.$store.state.otherPages[this.model];
      },
      set(value) {
        console.log(value);
        this.$store.commit('otherPages/updateForm', {
          [this.model]: value,
        });
      },
    },
  },
};
</script>
